module.exports = __webpack_public_path__ + "img/LUNA.0b02aa4b.svg";